import { useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { ROUTES } from "@/configs/routesConfig";
import { emptyUserImage, isEmpty, removeAuthCookies } from "@/utils/helpers";
import { getProfile } from "@/utils/selectors";
import { logoutUser } from '@/store/auth/authActions';
import { refreshCache } from '@/store/base/actions';
import { useProfile } from '@/hooks/useProfile';

const HeaderProfile = memo(() => {
  const dispatch = useDispatch();
  const profile = useSelector(getProfile);
  const history = useHistory();
  const { isAdmin } = useProfile();
  const handleClickLogout = () => {
    history.push(ROUTES.home);
    removeAuthCookies();
    dispatch(logoutUser());
  };

  //Profile Dropdown
  const [isOpenProfileDropdown, setOpenProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setOpenProfileDropdown((val) => !val);
  };

  const { t } = useTranslation();
  const handleClickRefreshCache = async () => {
    const res = await refreshCache();
    if (res?.ok) {
      toast.success(t('cache.update_success'));
    } else {
      toast.success(t('cache.update_error'));
    }
  };

  const userPhoto = profile?.psychologist?.photo?.xs || profile?.nutritionist?.photo?.xs || profile?.photo;

  return (
    <Dropdown
      className="d-inline-block"
      isOpen={isOpenProfileDropdown}
      toggle={toggleProfileDropdown}
    >
      <DropdownToggle
        tag="a"
        type="button"
        className="btn header-item user text-start d-flex align-items-center"
        id="page-header-user-dropdown"
        to="#"
      >
        <img
          className="rounded-circle header-profile-user"
          src={!isEmpty(userPhoto) ? userPhoto : emptyUserImage}
          alt="Avatar"
        />
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end pt-0">
        <div className="p-3 border-bottom">
          <h6 className="mb-0">{profile?.fullname || profile?.username}</h6>
          <p className="mb-0 font-size-11 text-muted">
            {t(`roles.${profile?.user_role}`)}
          </p>
        </div>
        {isAdmin && (
          <DropdownItem onClick={handleClickRefreshCache}>
            <i className="mdi mdi-sync text-muted font-size-16 align-middle me-1"></i>{' '}
            <span className="align-middle">
              {t('profile_menu.btn_refresh_cache')}
            </span>
          </DropdownItem>
        )}
        <DropdownItem onClick={handleClickLogout}>
          <i className="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>{' '}
          <span className="align-middle">{t('profile_menu.btn_logout')}</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
})

export default HeaderProfile;
